import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./customBaseQuery";
import { PidApiUserType } from "@lxp-app/pages/event-review/Utils/pidApiUserType";

export const SpeakersUtility = createApi({
  reducerPath: "speakersUtility",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["speakersdata"],
  endpoints: (builder) => ({
    getSpeakers: builder.query({
      query: ({
        pageNumber,
        pageSize,
        sortKey,
        sortOrder,
        data
      }: PidApiUserType) => ({
        url: `/pid/profile/detail/paginated/enable-ignored`,
        method: "POST",
        params: {
          pageNumber: pageNumber || 1,
          pageSize: pageSize || 6,
          sortKey: sortKey || "createdat",
          sortOrder: sortOrder || "DESC"
        },
        body: data
      }),
      extraOptions: { service: "PID" }
    })
  })
});

export const { useGetSpeakersQuery, useLazyGetSpeakersQuery } = SpeakersUtility;
